const PSState = require('PSState');
const LoadConfig = require('LoadConfig');
const Events = require('PSEvents');

cc.Class({
    extends: cc.Component,

    onLoad() {
        if (window.PSGames.launchParams && window.PSGames.launchParams.cheat) {
            this._init();
        } else {
            this.node.destroy();
        }
    },

    onDestroy() {
        if (this.gui && this.gui.destroy) {
            this.gui.destroy();
        }
    },

    /**
    *
    example cheat config
       cheatConfig: {
           reelsAmount: 5,
           // B1 - main game
           // B2 - FS
           reelsets: ['B1', 'B2'],
           cheats: [
               { id: '<1', reelset: 'B1', result: [[ 1, 1, 0, 0, 0]] },
               { id: '>=1', reelset: 'B1', result: [[ 5, 4, 3, 0, 0]] },
               { id: '>=5', reelset: 'B1', result: [[ 3, 0, 0, 8, 6]] },
               { id: '>=10', reelset: 'B1', result: [[ 0, 0, 0, 0, 0]] },
               { id: '>=20', reelset: 'B1', result: [[ 0, 0, 0, 0, 0]] },
               { id: '>=40', reelset: 'B1', result: [[ 0, 0, 0, 0, 0]] },
               { id: '>=80', reelset: 'B1', result: [[ 0, 0, 0, 0, 0]] },
               { id: 'HV1', reelset: 'B1', result: [[2, 0, 0, 7, 5]] },
               { id: 'HV2', reelset: 'B1', result: [[ 5, 4, 3, 0, 0]] },
               { id: 'HV3', reelset: 'B1', result: [[ 15, 6, 7, 5, 8]] },
               { id: 'HV4', reelset: 'B1', result: [[ 1, 23, 12, 3, 3]] },
               { id: 'HV5', reelset: 'B1', result: [[ 5, 7, 3, 0, 0]] },
               { id: 'HV6', reelset: 'B1', result: [[ 0, 3, 0, 19, 20]] },
               { id: 'LV1', reelset: 'B1', result: [[ 12, 0, 8, 9, 9]] },
               { id: 'LV2', reelset: 'B1', result: [[ 3, 8, 2, 6, 4]] },
               { id: 'LV3', reelset: 'B1', result: [[ 6, 2, 5, 4, 7]] },
               { id: 'LV4', reelset: 'B1', result: [[ 14, 11, 9, 2, 1]] },
           ],
           debugEvents: [
               { id: 'BIG_WIN' },
               { id: 'MEGA_WIN' },
               { id: 'EPIC_WIN' },
               { id: 'SLAMSTOP_WIN' },
           ]
       }
   */
    _init() {
        const rigger = window.PSGames.CommonAPI.Rigger;
        const gui = new dat.GUI({
            name: 'Cheat Panel',
            height: 200,
            closeOnTop: true
        });
        gui.width = 200;

        this.gui = gui;

        const { reelsAmount, reelsets, cheats = [{ id: 'NONE' }], debugEvents = [{ id: 'NONE' }] } = LoadConfig.cheatConfig;

        const defaultReel = reelsets[0];
        const defaultCheat = cheats[0].id;
        const defaultEvent = debugEvents[0].id;
        const obj = {
            reelset: defaultReel,
            cheat: defaultCheat,
            remoteCheat: '',
            event: defaultEvent,
            isLockManualCheat: false,
            isLockCheat: false,
            reelsets: reelsets,
            _activeCheat: null,
            'cheats': cheats.map(v => v.id),
            'events': debugEvents.map(v => v.id),
            rig: () => {
                const arr = [];
                for (let i = 0; i < reelsAmount; i++) {
                    arr.push(obj['reel' + (i + 1)]);
                }
                rigger.triggerRiggedAction(PSState.configState, obj.reelset, arr).
                    then((result) => { cc.log(result) });
            },
            rigCheat: () => {
                const _cheat = cheats.find(v => v.id === obj.cheat);

                if (_cheat.id === 'NONE') {
                    return;
                }
                if (obj._activeCheat !== obj.cheat) {
                    obj._activeCheat = obj.cheat;
                    obj._rigCtr = 0;
                    obj._cheat = _cheat;
                }

                if (_cheat) {
                    if (_cheat.type === 'json') {
                        rigger.triggerCheat(JSON.stringify(_cheat.data)).then(result => {
                            cc.log('rig: ' + result);
                        })
                    } else {
                        rigger.triggerRiggedAction(PSState.configState, _cheat.reelset, _cheat.result[obj._rigCtr]).
                        then((result) => { cc.log('rig: ' + result) });
                    }

                }
            },
            runEvent: () => {
                cc.game.emit(obj.event);
            },
            rigRemoteCheat: () => {
                rigger.triggerCheat(obj.remoteCheat).
                    then((result) => { cc.log('rig: ' + result) });
            }
        };

    for (let i = 0; i < reelsAmount; i++) {
            obj['reel' + (i + 1)] = 0;
        }

        // debug events
        Events.subscribe(Events.GAME_ROUND_ENDED, () => {
            if (obj.isLockManualCheat) {
                obj.rig();
            }
            if (obj._activeCheat !== null) {
                obj._rigCtr++;

                if (obj._cheat.type === 'json' || obj._rigCtr > obj._cheat.result.length - 1) {
                    obj._rigCtr = 0;
                    obj._activeCheat = null;
                    obj._cheat = null;

                    if (obj.isLockCheat) {
                        obj.rigCheat();
                    }
                } else {
                    obj.rigCheat();
                }
            }

        });

        gui.hideable = true;
        this._addManualRig(gui, obj, reelsAmount)
        this._addLocalRig(gui, obj)
        this._addRemoteRig(gui, obj, rigger)
        this._addEventsRig(gui, obj)
        this._addTopBarTester(gui);

        this.obj = obj;
    },

    _addEventsRig(gui, obj) {
        const _eventsFolder = gui.addFolder('Events');
        _eventsFolder.add(obj, 'event', obj.events);
        _eventsFolder.add(obj, 'runEvent');
    },

    _addManualRig(gui, obj, reelsAmount) {
        const _manualCheatFolder = gui.addFolder('Manual Rig');

        for (let i = 0; i < reelsAmount; i++) {
            _manualCheatFolder.add(obj, 'reel' + (i + 1));
        }

        _manualCheatFolder.add(obj, 'reelset', obj.reelsets);
        this.isLockManualCheatController = _manualCheatFolder.add(obj, 'isLockManualCheat');
        _manualCheatFolder.add(obj, 'rig');
    },

    _addLocalRig(gui, obj) {
        const _cheatsFolder = gui.addFolder('Cheats');

        _cheatsFolder.add(obj, 'cheat', obj.cheats);
        _cheatsFolder.add(obj, 'rigCheat');
        const isLockCheatController = _cheatsFolder.add(obj, 'isLockCheat');

        isLockCheatController.onChange((isLockCheat) => {
            if (isLockCheat) {
                this.isLockManualCheatController.setValue(false);
            }
        })

        this.isLockManualCheatController.onChange((isLockManual) => {
            if (isLockManual) {
                isLockCheatController.setValue(false);
            }
        })
    },

    _addRemoteRig(gui, obj, rigger) {
        const cheats = rigger.listCheats();

        if (cheats.length < 1) return;

        obj.remoteCheat = cheats[0];

        const _eventsFolder = gui.addFolder('RemoteCheats');

        _eventsFolder.add(obj, 'remoteCheat', cheats);
        _eventsFolder.add(obj, 'rigRemoteCheat');
    },

    _addTopBarTester(gui, obj, rigger) {

        const eventsFolder = gui.addFolder('Top Bar Tester');

        const topBar = {
            height: 0,

            update: () => {

            }
        }





        eventsFolder.add(topBar, 'height', 0).onFinishChange((value) => {
            PSState.updateGameInnerCanvasSize({
                top: {
                    test: value
                }
            });
        });
    }
});
